// Comandos do agregado Backlog Inicial (issue #68, ADR-0019) — o saldo que já
// existia num Cliente antes do sistema entrar em operação. A tela edita uma
// grade de Tipo×Quantidade para um Cliente e grava tudo no "Salvar", então só
// há `definir`, igual ao agregado Lista.

import type { Snapshot } from "../domain/snapshot.ts";
import { definirBacklogInicial } from "../domain/backlog-inicial.ts";
import { assertNunca } from "../lib/assert-nunca.ts";
import { comoObjeto, exigirTexto, lista, paraNumero } from "./_forma.ts";
import type { ContextoComando } from "./lotes.ts";

export interface LinhaBacklogInicialComando {
  tipoId: string;
  quantidade: number;
}

export type ComandoBacklogInicial = {
  tipo: "definir";
  clienteId: string;
  linhas: LinhaBacklogInicialComando[];
};

export function executarComandoBacklogInicial(
  snapshot: Snapshot,
  cmd: ComandoBacklogInicial,
  _ctx: ContextoComando,
): Snapshot {
  switch (cmd.tipo) {
    case "definir":
      return definirBacklogInicial(snapshot, cmd.clienteId, cmd.linhas);
    default:
      return assertNunca(cmd.tipo);
  }
}

function validarLinhas(valor: unknown): LinhaBacklogInicialComando[] {
  return lista(valor, "linhas", (item, i) => {
    const o = comoObjeto(item, `Linha #${i + 1}`);
    return {
      tipoId: exigirTexto(o.tipoId, `linhas[${i}].tipoId`),
      quantidade: paraNumero(o.quantidade),
    };
  });
}

export function validarComandoBacklogInicial(valor: unknown): ComandoBacklogInicial {
  const c = comoObjeto(valor, "Comando de backlog inicial");
  if (c.tipo !== "definir") {
    throw new Error(`Tipo de comando de backlog inicial desconhecido: ${String(c.tipo)}.`);
  }
  return {
    tipo: "definir",
    clienteId: exigirTexto(c.clienteId, "clienteId"),
    linhas: validarLinhas(c.linhas),
  };
}
